import { BlurEvent, ClickEvent, DataSourceMode, Layout, Panel, Snackbar, Textbox, Toast, ValidationResult } from "@mcleod/components";
import { Alignment, Api, EmailUtil, StringUtil } from "@mcleod/core";
import { AutogenLayoutSendLoadTender } from "./autogen/AutogenLayoutSendLoadTender";

export class SendLoadTender extends AutogenLayoutSendLoadTender {
    private _parentPanel: Panel;
    private _isIntercompany: boolean;
    public useLayoutClickListener: boolean = true;
    public externalButtonControl: boolean = false; // Flag to indicate external button control

    override onLoad(): void {
        this.textboxContact.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
            return this.emailDomainValidator(this.textboxContact, mode);
        };
        this.textboxAddContact.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
            return this.emailDomainValidator(this.textboxAddContact, mode);
        };

    }

    private emailDomainValidator(textbox: Textbox, mode: DataSourceMode) {
        if (mode === DataSourceMode.SEARCH) {
            return null;
        }
        const domains = textbox.text.split(",");
        for (const domain of domains) {
            if (!StringUtil.isEmptyString(domain) && !EmailUtil.isValidEmail(domain)) {
                return { component: textbox, isValid: false, validationMessage: "Invalid domain format. Email domains must be in the following format [abc.com,xyz.com]" }
            }
        }
        return null
    }

    textboxValidationByOnBlur(event: BlurEvent) {
        if (!(this.textboxMustRespondBy.validateSimple() && this.textboxAddContact.validateSimple(false, true) && this.textboxContact.validateSimple(false, true))) {
            this.buttonSend.enabled = false;
        }
        else {
            this.buttonSend.enabled = true;
        }
    }

    public get isIntercompany(): boolean {
        return this._isIntercompany;
    }

    public set isIntercompany(value: boolean) {
        this._isIntercompany = value;
    }

    public get parentPanel(): Panel {
        return this._parentPanel;
    }

    public set parentPanel(value: Panel) {
        this._parentPanel = value;
    }

    public doAfterLoadTenderSent: () => void;

    buttonSendOnClick(event: ClickEvent) {
        if (!this.useLayoutClickListener) return;
        if (!this.externalButtonControl) {
            this.buttonSend.busy = true;
        }
        const moveId = this.mainDataSource.activeRow.get("moveid_out");
        const isAuto = this.mainDataSource.activeRow.get("is_auto_out");
        const carrierId = this.labelCarrierId.text;
        const purpose = this.labelPurpose.text;
        const mrb = this.textboxMustRespondBy.text;
        const contacts = this.textboxContact.text as string;
        const addlContacts = this.textboxAddContact.text;

        let allContacts: Array<string>;
        let cString = "";

        if (isAuto == "false" && !this.isIntercompany) {
            if (!StringUtil.isEmptyString(contacts)) {
                allContacts = contacts.split(",");
                for (let i = 0; i < allContacts.length; i++) {
                    if (i > 0) cString += ",";
                    cString += allContacts[i];
                }
            }

            if (!StringUtil.isEmptyString(addlContacts)) {
                const addContactList: string[] = addlContacts.split(",");

                addContactList.forEach((item) => {
                    if (!StringUtil.isEmptyString(cString)) cString += ",";
                    cString += item as string;
                });
            }

            Api.post("lme/datafusion/send-tender", {
                carrier: carrierId, move_id: moveId, respond_by: mrb, purpose: purpose, contacts: cString
            }).then(response => {
                if (!this.externalButtonControl) {
                    this.buttonSend.busy = false;
                }
                this.slideOut().then(() => {
                    if (response.data[0]?.["tendersent"]) {
                        Toast.showSuccessToast("Successfully sent " + purpose + " tender for movement " + moveId + " in batch " + response.data[0].batchid);
                    } else {
                        Snackbar.showWarningSnackbar("Unable to send " + purpose + " tender for movement " + moveId + ".  " + response.data[0].text);
                    }
                });
            }).catch(error => {
                Snackbar.showWarningSnackbar("Unable to send " + purpose + " tender for movement " + moveId + ".  " + error);
            });
        }
    }

    static sendLoadTender(carrierId: string, moveId: string, isCancel: string, refresh?: () => void) {
        const slideoutProps = {
            width: 1000, height: window.innerHeight, backgroundColor: "defaultBackground", top: 30, padding: 0,
            borderRadius: 4, borderWidth: 1, borderShadow: true, borderColor: "strokeSecondary"
        };
        Layout.getLayout("lme/datafusion/SendLoadTender", slideoutProps).addLayoutLoadListener(event => {
            const layout = event.target as SendLoadTender;
            layout.buttonCancel.addClickListener(() => layout.slideOut());
            if (refresh) {
                layout.addUnmountListener(() => refresh());
            }
            layout.buttonSendLater.visible = false;
            layout.search({ carrier: carrierId, move_id: moveId, is_cancel: isCancel, is_auto: "false" }).then(result => {
                if (result?.modelRows?.length > 0) {
                    layout.setAllDataSourcesToMode(DataSourceMode.UPDATE);
                    layout.slideIn({ direction: Alignment.RIGHT }, true, { closeOnClickOff: false, greyedBackground: true });
                }
            });
        });
    }
}
